//import React from 'react';
import { PropTypes } from 'prop-types';
import { ChartBase } from './chartBase';

const returnNull = () => null;

const isArraysOfNumberEquals = (a1, a2) => {
    const _a1 = a1 || [];
    const _a2 = a2 || [];

    let r = _a1 == _a2;

    if (!r) {
        r = 
            !_a1.some(p => _a2.indexOf(p) < 0) &&
            !_a2.some(p => _a1.indexOf(p) < 0);
    }

    return r;
}

export class SimpleLineChart extends ChartBase {
    constructor(props, ...other) {
        super(props, ...other);
        this.state = {
            ...self.state,
            invisibleColumns: (props.invisibleColumns || []).slice(),
        };

        this.handleInvisibleColumnsChange = this.handleInvisibleColumnsChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const props = this.props;
        const state = this.state;
        
        const result = 
            super.shouldComponentUpdate(nextProps, nextState) ||
            !isArraysOfNumberEquals(state.invisibleColumns, nextState.invisibleColumns) ||
            (props.dataTable != nextProps.dataTable) ||
            !isArraysOfNumberEquals(props.hiddenColumns, nextProps.hiddenColumns) ||
            !isArraysOfNumberEquals(props.invisibleColumns, nextProps.invisibleColumns) ||
            (props.options != nextProps.options) && (JSON.stringify(props.options) != JSON.stringify(nextProps.options));
        
        return result;
    }
    
    componentDidUpdate(prevProps, ...other) {
        const self = this;

        if (!isArraysOfNumberEquals(self.props.invisibleColumns, prevProps.invisibleColumns)) {
            self.setState({invisibleColumns: (self.props.invisibleColumns || []).slice()});
        }
        else {
            super.componentDidUpdate(prevProps, ...other)
        }
    }

    handleInvisibleColumnsChange() {
        const self = this;
        const {onInvisibleColumnsChange} = self.props;

        if (typeof onInvisibleColumnsChange === 'function') {
            onInvisibleColumnsChange(self.state.invisibleColumns.slice());
        }
    }

    handleReady(data) {
        super.handleReady(data);

        const self = this;

        if (self._isMounted && Boolean(self.chartNode.current) && self.props.toggleColumnVisibleOnLegendClick) {
            $(self.chartNode.current)
                .find('g')
                .each((i, e) => {
                    if ((e.logicalname || '').match(/^legendentry#[0-9]+$/)) {
                        $(e).css('cursor', 'pointer');
                    }
                });
        }
    }

    handleClick(data) {
        super.handleClick(data);

        const self = this;

        if (self._isMounted && data.targetID.match(/^legendentry#[0-9]+$/)) {
            const colIndex = parseInt(data.targetID.replace('legendentry#', '')) + 1;

            let invisibleColumns = self.state.invisibleColumns;

            if (invisibleColumns.indexOf(colIndex) >= 0) {
                invisibleColumns = invisibleColumns.filter(p => p != colIndex);
            }
            else {
                invisibleColumns = invisibleColumns.concat([colIndex]);
            }
            
            self.setState({invisibleColumns: invisibleColumns}, self.handleInvisibleColumnsChange);
        }
    }

    drawChart() {
        const self = this;

        if (!Boolean(window['google'])) {
            return;
        }

        const {dataTable, options, hiddenColumns, toggleColumnVisibleOnLegendClick} = self.props;

        if (!Boolean(dataTable) || (dataTable.cols.length  == 0)) {
            self.destroyChart();
            return;
        }

        if (!Boolean(self.chart)) {
            self.chart = new google.visualization.LineChart(self.chartNode.current);
            self.attachEventHandlers(self.chart);
        }

        const opts = $.extend(
            true, 
            {            
                fontName: ChartBase.ChartFontName,
                fontSize: ChartBase.ChartFontSize,
            }, 
            options
        );

        opts.series = opts.series || {};
        
        const visibleColumns = [];

        dataTable.cols.forEach((col, ci) => {
            if ((ci > 0) && (!Boolean(col.role) || (col.role == 'data')) && Boolean(col.p)) {
                opts.series[ci - 1] = {...opts.series[ci - 1], ...col.p.series};
            }

            if ((ci > 0) && Boolean(toggleColumnVisibleOnLegendClick) && (self.state.invisibleColumns.indexOf(ci) >= 0)) {
                visibleColumns.push({
                    calc: returnNull,
                    type: col.type,
                    label: col.label
                });
                opts.series[ci - 1].color = "#dddddd";
            }
            else {
                visibleColumns.push(ci);
            }
        });
        
        const dt = new google.visualization.DataTable(dataTable);
        const dataView = new google.visualization.DataView(dt);

        dataView.setColumns(visibleColumns);

        if (Boolean(hiddenColumns) && (hiddenColumns.length > 0)) {
            dataView.hideColumns(hiddenColumns);
        }

        self.chart.draw(dataView, opts);
        //self.chart.draw(dataView, google.charts.Line.convertOptions(opts));
    }
}

const textStylePropTypes = {
    color: PropTypes.string,
    fontName: PropTypes.string,
    fontSize: PropTypes.number,
    bold: PropTypes.bool,
    italic: PropTypes.bool
}

const gridLinesPropTypes = {
    color: PropTypes.string,
    count: PropTypes.number,
    interval: PropTypes.arrayOf(PropTypes.number),
    minSpacing: PropTypes.number,
    multiple: PropTypes.number,
    units: PropTypes.shape({
        years: PropTypes.shape({format: PropTypes.string}),
        months: PropTypes.shape({format: PropTypes.string}),
        days: PropTypes.shape({format: PropTypes.string}),
        hours: PropTypes.shape({format: PropTypes.string}),
        minutes: PropTypes.shape({format: PropTypes.string}),
        seconds: PropTypes.shape({format: PropTypes.string}),
        milliseconds: PropTypes.shape({format: PropTypes.string})
    })
};

const axisPropTypes = {
    baseline: PropTypes.number,
    baselineColor: PropTypes.string,
    direction: PropTypes.oneOf([1, -1]),
    format: PropTypes.string,
    gridlines: PropTypes.shape(gridLinesPropTypes),
    minorGridlines: PropTypes.shape(gridLinesPropTypes),
    logScale: PropTypes.bool,
    scaleType: PropTypes.oneOf([null, 'log', 'mirrorLog']),
    textPosition: PropTypes.oneOf(['none', 'in', 'out']),
    textStyle: PropTypes.shape(textStylePropTypes),
    ticks: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.shape({v: PropTypes.any, f: PropTypes.string})])),
    title: PropTypes.string,
    titleTextStyle: PropTypes.shape(textStylePropTypes),
    allowContainerBoundaryTextCutoff: PropTypes.bool,
    slantedText: PropTypes.bool,
    slantedTextAngle: PropTypes.number,
    maxAlternation: PropTypes.number,
    maxTextLines: PropTypes.number,
    minTextSpacing: PropTypes.number,
    showTextEvery: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    viewWindowMode: PropTypes.oneOf(['pretty', 'maximized', 'explicit']),
    viewWindow: PropTypes.shape({
        max: PropTypes.number,
        min: PropTypes.number
    })
}

const annotationsPropTypes = {
    boxStyle: PropTypes.shape({
        stroke: PropTypes.string,
        strokeWidth: PropTypes.number,
        rx: PropTypes.number,
        ry: PropTypes.number,
        gradient: PropTypes.shape({
            color1: PropTypes.string,
            color2: PropTypes.string,
            x1: PropTypes.string,
            y1: PropTypes.string,
            x2: PropTypes.string,
            y2: PropTypes.string,
            useObjectBoundingBoxUnits: PropTypes.bool
        })
    }),
    datum: PropTypes.shape({
        steam: PropTypes.shape({
            color: PropTypes.string,
            length: PropTypes.number
        }),
        style: PropTypes.oneOf(['point', 'line'])
    }),
    domain: PropTypes.shape({
        steam: PropTypes.shape({
            color: PropTypes.string,
            length: PropTypes.number
        }),
        style: PropTypes.oneOf(['point', 'line'])
    }),
    highContrast: PropTypes.bool,
    stem: PropTypes.shape({
        color: PropTypes.string,
        length: PropTypes.number
    }),
    style: PropTypes.oneOf(['point', 'line']),
    textStyle: PropTypes.shape({
        fontName: PropTypes.string,
        fontSize: PropTypes.number,
        bold: PropTypes.bool,
        italic: PropTypes.bool,
        color: PropTypes.string,
        auraColor: PropTypes.string,
        opacity: PropTypes.number
    })
};

const seriesPropTypes = {
    annotations: PropTypes.shape(annotationsPropTypes),
    color: PropTypes.string,
    curveType: PropTypes.oneOf(['none', 'function']),
    labelInLegend: PropTypes.bool,
    lineDashStyle: PropTypes.arrayOf(PropTypes.number),
    lineWidth: PropTypes.number,
    pointShape: PropTypes.oneOf(['circle', 'triangle', 'square', 'diamond', 'star', 'polygon']),
    pointSize: PropTypes.number,
    pointsVisible: PropTypes.bool,
    targetAxisIndex: PropTypes.number,
    visibleInLegend: PropTypes.bool
};

const tradelinePropTypes = {
    color: PropTypes.string,
    degree: PropTypes.number,
    labelInLegend: PropTypes.string,
    lineWidth: PropTypes.number,
    opacity: PropTypes.number,
    pointSize: PropTypes.number,
    pointsVisible: PropTypes.bool,
    showR2: PropTypes.bool,
    type: PropTypes.oneOf(['linear', 'exponential', 'polynomial']),
    visibleInLegend: PropTypes.bool
};

SimpleLineChart.propTypes = {
    ...ChartBase.propTypes, 
    ...{
        options: PropTypes.shape({
            aggregationTarget: PropTypes.oneOf(['category', 'series', 'auto', 'none']),
            animation: PropTypes.shape({
                duration: PropTypes.number,
                startup: PropTypes.bool,
                easing: PropTypes.oneOf(['linear', 'in', 'out', 'inAndOut'])
            }),
            annotations: PropTypes.shape(annotationsPropTypes),
            axisTitlesPosition: PropTypes.oneOf(['in', 'out', 'none']),
            backgroundColor: PropTypes.oneOfType([
                PropTypes.string, 
                PropTypes.shape({
                    stroke: PropTypes.string,
                    strokeWidth: PropTypes.number,
                    fill: PropTypes.string
                })
            ]),
            chartArea: PropTypes.shape({
                backgroundColor: PropTypes.oneOfType([
                    PropTypes.string, 
                    PropTypes.shape({
                        stroke: PropTypes.string,
                        strokeWidth: PropTypes.number
                    })
                ]),
                left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            }),
            colors: PropTypes.arrayOf(PropTypes.string),
            crosshair: PropTypes.shape({
                color: PropTypes.string,
                focused: PropTypes.shape({
                    color: PropTypes.string,
                    opacity: PropTypes.number
                }),
                opacity: PropTypes.number,
                orientation: PropTypes.oneOf(['vertical', 'horizontal', 'both']),
                selected: PropTypes.shape({
                    color: PropTypes.string,
                    opacity: PropTypes.number
                }),
                trigger: PropTypes.oneOf(['focus', 'selection', 'both'])
            }),
            curveType: PropTypes.oneOf(['none', 'function']),
            dataOpacity: PropTypes.number,
            enableInteractivity: PropTypes.bool,
            explorer: PropTypes.shape({
                actions: PropTypes.arrayOf(PropTypes.oneOf(['dragToPan', 'dragToZoom', 'rightClickToReset'])),
                axis: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
                keepInBounds: PropTypes.bool,
                maxZoomIn: PropTypes.number,
                maxZoomOut: PropTypes.number,
                zoomDelta: PropTypes.number
            }),
            focusTarget: PropTypes.oneOf(['datum', 'category']),
            fontSize: PropTypes.number,
            fontName: PropTypes.string,
            forceIFrame: PropTypes.bool,
            hAxis: PropTypes.shape(axisPropTypes),
            height: PropTypes.number,
            interpolateNulls: PropTypes.bool,
            legend: PropTypes.shape({
                alignment: PropTypes.oneOf(['start', 'center', 'end']),
                maxLines: PropTypes.number,
                pageIndex: PropTypes.number,
                position: PropTypes.oneOf(['bottom', 'left', 'in', 'none', 'right', 'top']),
                textStyle: PropTypes.shape(textStylePropTypes)
            }),
            lineDashStyle: PropTypes.arrayOf(PropTypes.number),
            lineWidth: PropTypes.number,
            orientation: PropTypes.oneOf(['vertical', 'horizontal']),
            pointShape: PropTypes.oneOf(['circle', 'triangle', 'square', 'diamond', 'star', 'polygon']),
            pointSize: PropTypes.number,
            pointsVisible: PropTypes.bool,
            reverseCategories: PropTypes.bool,
            selectionMode: PropTypes.oneOf(['single', 'multiple']),
            series: PropTypes.oneOfType([
                PropTypes.shape({
                    0: PropTypes.shape(seriesPropTypes),
                    1: PropTypes.shape(seriesPropTypes),
                    2: PropTypes.shape(seriesPropTypes),
                    3: PropTypes.shape(seriesPropTypes),
                    4: PropTypes.shape(seriesPropTypes),
                    5: PropTypes.shape(seriesPropTypes),
                    6: PropTypes.shape(seriesPropTypes),
                    7: PropTypes.shape(seriesPropTypes),
                    8: PropTypes.shape(seriesPropTypes),
                    9: PropTypes.shape(seriesPropTypes)
                }), 
                PropTypes.arrayOf(PropTypes.shape(seriesPropTypes))
            ]),
            theme: PropTypes.oneOf(['maximized']),
            title: PropTypes.string,
            titlePosition: PropTypes.oneOf(['in', 'out', 'none']),
            titleTextStyle: PropTypes.shape(textStylePropTypes),
            tooltip: PropTypes.shape({
                ignoreBounds: PropTypes.bool,
                isHtml: PropTypes.bool,
                showColorCode: PropTypes.bool,
                textStyle: PropTypes.shape(textStylePropTypes),
                trigger: PropTypes.oneOf(['focus', 'none', 'selection', 'both']),
                trendlines: PropTypes.object,
            }),
            trendlines: PropTypes.shape({
                0: PropTypes.shape(tradelinePropTypes),
                1: PropTypes.shape(tradelinePropTypes),
                2: PropTypes.shape(tradelinePropTypes),
                3: PropTypes.shape(tradelinePropTypes),
                4: PropTypes.shape(tradelinePropTypes),
                5: PropTypes.shape(tradelinePropTypes),
                6: PropTypes.shape(tradelinePropTypes),
                7: PropTypes.shape(tradelinePropTypes),
                8: PropTypes.shape(tradelinePropTypes),
                9: PropTypes.shape(tradelinePropTypes)
            }),
            vAxes: PropTypes.shape({
                1: PropTypes.shape(axisPropTypes),
                2: PropTypes.shape(axisPropTypes),
                3: PropTypes.shape(axisPropTypes),
                4: PropTypes.shape(axisPropTypes),
                5: PropTypes.shape(axisPropTypes),
                6: PropTypes.shape(axisPropTypes),
                7: PropTypes.shape(axisPropTypes),
                8: PropTypes.shape(axisPropTypes),
                9: PropTypes.shape(axisPropTypes)
            }),
            vAxis: PropTypes.shape(axisPropTypes),
            width: PropTypes.number,
        }),
        hiddenColumns: PropTypes.arrayOf(PropTypes.number),
        invisibleColumns: PropTypes.arrayOf(PropTypes.number),
        toggleColumnVisibleOnLegendClick: PropTypes.bool,
        onInvisibleColumnsChange: PropTypes.func,
    }
}
SimpleLineChart.defaultProps = { 
    ...ChartBase.defaultProps, 
    toggleColumnVisibleOnLegendClick: false,
}